/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useParams, useRouter } from '@tanstack/react-router'
import SideBySideLayout from './SideBySideLayout'
import SurveyAndStudentLoadingModal from '../modals/SurveyAndStudentLoadingModal'
import { emptyStudent } from './assets/default-objects'
import { useIsAuthenticated } from '@azure/msal-react'
import { api } from '../shared/ApiProvider'

export default function ProcessCrossReference() {
  // This is where data is gathered based on the params sent to DB
  const params = useParams({ from: '/form/$id' })
  const { id } = params
  const router = useRouter()
  const isAuthenticated = useIsAuthenticated()

  const [survey, setSurvey] = useState({})
  const [student, setStudent] = useState({})
  const [matchedStudent, setMatchedStudent] = useState(null)
  // These are the variables that inform what the loading modal will display (getting survey, getting student, error....)
  const [gettingSurvey, setGettingSurvey] = useState(false)
  const [gettingStudent, setGettingStudent] = useState(false)
  const [errorReceived, setErrorReceived] = useState(false)
  const [dataLoaded, setDataLoaded] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [noStudentFound, setNoStudentFound] = useState(false)
  /*
    Runs on initial load of the page and retrieves the 'starting' information for the comparison page 
    (survey data and matching student data. All altered information is then stored in the formData state, maintained
        by the StudentDataLayout component.
    */

  useEffect(() => {
    async function fetchData() {
      try {
        // Retrieves survey and student information, based on survey ID
        setGettingSurvey(true)
        const { data } = await api.get(`/surveyandstudent/${id}`)
        const { surveyResponse, student, matchedStudent } = data
        //
        surveyResponse.specificEnrollingAtDate = surveyResponse.enrollingAtDate
        surveyResponse.enrollingAtDate = formatEnrollingAtDate(
          surveyResponse.enrollingAtDate
        )
        surveyResponse.gradeEntering = formatGradeEntering(
          surveyResponse.gradeEntering
        )
        student.enrollingAtDate = formatEnrollingAtDate(student.enrollingAtDate)
        //
        setGettingSurvey(false)
        setGettingStudent(false)
        setSurvey(surveyResponse)
        if (surveyResponse === null) {
          setErrorReceived(true)
          setErrorMessage('No record found!')
        }

        if (student.permNumber === null) {
          setStudent(emptyStudent)
          setNoStudentFound(true)
        } else {
          setStudent(student)
        }
        setMatchedStudent(matchedStudent)
        setDataLoaded(true)
      } catch (error) {
        // catches error for survey query.
        console.error(error)
        setGettingSurvey(false)
        setErrorReceived(true)
        setErrorMessage(error)
      }
    }

    setGettingStudent(false)
    fetchData()
    //axios thing eventually to query for individual survey- abstract out
    // use id or PERM number or SOMETHING to hit the other database (if it can)
  }, [id])

  const formatEnrollingAtDate = (date) => {
    if (date) {
      const trimmed = date.trim()
      let startingDate = +trimmed.split('-')[0]
      return `${startingDate}-${startingDate + 1}`
    }
  }
  const formatGradeEntering = (str) => {
    if (str) {
      if (str === 'PreK') {
        return 'PreK'
      }
      if (str === 'K') {
        return 'K'
      } else if (str.length === 1) {
        return `0${str}`
      } else {
        return str
      }
    } else {
      return ' '
    }
  }

  return (
    <div>
      {dataLoaded ? (
        <SideBySideLayout
          survey={survey}
          student={student}
          matchedStudent={matchedStudent}
          noStudentFound={noStudentFound}
        />
      ) : null}
      <SurveyAndStudentLoadingModal
        show={!dataLoaded}
        gettingSurvey={gettingSurvey}
        errorMessage={errorMessage}
        gettingStudent={gettingStudent}
        errorReceived={errorReceived}
      />
    </div>
  )
}
